import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const ZapFastIcon = (props: SvgIconProps): React.ReactElement => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 17.5H4M11.5 12H3M13 6.5H7M17.5 15L13 21.5H19.5L15 15M13 2.5L15 8.5H11L13 2.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);

export default ZapFastIcon;
